import { ArchiveBoxIcon } from "@heroicons/react/20/solid";
import { useModalStore } from "@/stores/use-modal-store";
import { CustomDropdown, CustomDropdownItem } from "@/components/ui/dropdown";
import { ArchiveContextPackModal } from "../modals/archive-context-pack-modal";
import { ContextPack } from "@/api/studio/contexts/types/context.type";
import { useArchiveContextPack } from "@/api/studio/contexts/queries";
import { useSegment } from "@/hooks/use-segment";

/* Prop Types */
interface ContextDropdownProps {
  contextPack: ContextPack;
}

/*
 * ContextPackDropdown component
 * Simple component to keep the dropdown items for a context pack in one place
 */
export const ContextPackDropdown = ({ contextPack }: ContextDropdownProps) => {
  /* Stores */
  const { open } = useModalStore((state) => state.modalActions);

  /* Hooks */
  const { segmentTrackEvent } = useSegment();

  /* Queries */
  const { mutateAsync: unArchiveContextPack } = useArchiveContextPack();

  /* Handlers */
  const handleArchiveContextPack = (contextPack: ContextPack) => {
    if (contextPack.isArchived) {
      unArchiveContextPack({ contextPackId: contextPack.id, values: { isArchived: false } });

      // Segment event
      segmentTrackEvent("Context Pack Unarchived", {
        contextPackId: contextPack.id,
        name: contextPack.name,
        contextCount: contextPack?.contextCount,
      });
      return;
    }
    open(<ArchiveContextPackModal contextPack={contextPack} />);
  };

  /* Render */
  return (
    <CustomDropdown align="end">
      <CustomDropdownItem onClick={() => handleArchiveContextPack(contextPack)}>
        <ArchiveBoxIcon className="size-4" /> {contextPack.isArchived ? "Unarchive" : "Archive"}
      </CustomDropdownItem>
    </CustomDropdown>
  );
};
